<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="'Manage Options (' + data.dataOptions.length + ')'"
  [hideDefaultActions]="true"
>

<div crucibleDialogContent>
  <!-- Search Box -->
  <div class="search-section">
    <mat-form-field class="full-width">
      <mat-label>Search options</mat-label>
      <input matInput [(ngModel)]="searchText" placeholder="Filter by ID or description">
      @if (searchText) {
      <button matSuffix mat-icon-button (click)="searchText = ''" title="Clear search">
        <mat-icon fontIcon="mdi-close"></mat-icon>
      </button>
      }
    </mat-form-field>
  </div>

  <!-- Action Buttons -->
  @if (data.canEdit) {
  <div class="action-buttons">
    <button mat-icon-button (click)="handleAdd()" title="Add new option" style="outline: none;">
      <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle-outline"></mat-icon>
    </button>
    <button mat-icon-button (click)="handleImport()"
      [disabled]="data.canImport === false"
      matTooltip="Import options from file"
      style="outline: none;">
      <mat-icon class="mdi-24px" fontIcon="mdi-upload"></mat-icon>
    </button>
  </div>
  }

  <!-- Options Table -->
  <div class="options-table-container">
    <mat-table [dataSource]="filteredOptions" matSort matSortActive="displayOrder" matSortDirection="asc" (matSortChange)="onSortChange($event)">
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef class="actions-column"></mat-header-cell>
        <mat-cell *matCellDef="let option" class="actions-column">
          <button mat-icon-button (click)="handleEdit(option)" title="Edit this option">
            <mat-icon class="mdi-18px" fontIcon="mdi-square-edit-outline"></mat-icon>
          </button>
          <button mat-icon-button (click)="handleDelete(option)" title="Delete this option">
            <mat-icon class="mdi-18px" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="displayOrder">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="order-column">Order</mat-header-cell>
        <mat-cell *matCellDef="let option" class="order-column">{{ option.displayOrder }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="optionName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="name-column">ID</mat-header-cell>
        <mat-cell *matCellDef="let option" class="name-column">{{ option.optionName }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="optionValue">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="value-column">Description</mat-header-cell>
        <mat-cell *matCellDef="let option" class="value-column">{{ option.optionValue }}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
</div>

<ng-container crucibleDialogActions>
  <button matButton="filled" type="button" (click)="handleClose()">Close</button>
</ng-container>
</crucible-dialog>
